import accountProvider from '../account/AccountProvider';

export function getBasicAuthenticationHeaderValue(): string | undefined {
  const account = accountProvider.getAccountStorage();
  return !account.token || !account.userName
    ? undefined
    : 'Basic ' + btoa(`${account.userName}:${account.token}`);
}

export function getAuthorizedConfig() {
  const authHeaderValue = getBasicAuthenticationHeaderValue();
  const selectedCompanyId = accountProvider.getSelectedCompanyId();
  if (!authHeaderValue) {
    return {};
  } else {
    return {
      headers: {
        authorization: authHeaderValue,
        ...(selectedCompanyId ? {'X-SELECTED-COMPANY-ID': selectedCompanyId} : {}),
      }
    };
  }
}



// WEBPACK FOOTER //
// ./src/api/auth.ts